<template lang="pug">
    v-dialog(v-model='dialog' max-higth='500px' max-width='1200' )
        v-card( justify='center' max-width='1200')
            v-container
                v-row
                    v-col
                        v-img(:src='Customers.logoUrl' max-height='200' max-width='300' align='center'  )
                v-spacer
                    v-col(align='end')
                        Boton_imprimir(nombre_de_impresion='Documento_de_salida')
                v-container#Documento_de_salida
                    v-row
                        v-col
                            h1 Salida Nº :
                                span.grey--text.text--darken--4 {{Datos.numero_de_operacion}}
                    v-row(justify='center' align='center' )
                        v-container
                            v-row
                                v-col
                                    p Documento de operacion :          
                                        span.grey--text.text--darken--4 {{Datos.documento_de_operacion}}
                                    p Generado por : 
                                        span.grey--text.text--darken--4 {{Datos.creado_por}}
                                    p Serie guía :
                                        span.grey--text.text--darken--4 {{Datos.serie_guia}}
                                    p Cliente denominación :   
                                        span.grey--text.text--darken--4 {{Datos.cliente_denominacion}}
                                    p Cliente E-mail :   
                                        span.grey--text.text--darken--4 {{Datos.cliente_email}}
                                    p Cliente número de documento:   
                                        span.grey--text.text--darken--4 {{Datos.cliente_numero_de_documento}}
                                v-col
                                    p Conductor denominación :   
                                        span.grey--text.text--darken--4 {{Datos.conductor_denominacion==''?'no existe' :Datos.conductor_denominacion }}
                                    p Estado del documento :   
                                        span.grey--text.text--darken--4 {{Datos.estado_del_documento}}
                                    p Fecha de emision :   
                                        span.grey--text.text--darken--4 {{Datos.fecha_de_emision}}
                                    p Fecha de inicio de traslado :   
                                        span.grey--text.text--darken--4 {{Datos.fecha_de_inicio_de_traslado}}
                    v-row(justify='center' align='center' )
                        v-col
                            v-data-table(  :headers='headers' :items='Datos.items' item-key='key' align='center' hide-default-footer )
                    v-row
                        v-col 
                            br
                            br
                            P Comprobante :
                                span.grey--text.text--darken--4 {{Datos.nombre_de_documento_comprobante }}
                            P Nombre de comprobante reversion  :          
                                span.grey--text.text--darken--4 {{Datos.nombre_de_documento_comprobante_reversion }}
                    v-row
                        v-col(align='right')
                            
                            h2 Atentamente 
                            p 
                                span.grey--text.text--darken--4 {{Datos.creado_por}}
                            P 
                                span.grey--text.text--darken--4 {{Customers.name}}
                    v-row.d-print-none(justify='center' width='100%')
                        v-container 
                            v-row
                                v-btn( @click='cerrar()' color='primary' outlined rounded ) cerrar
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
  data:()=>({
  

    headers:[
      {text:'Productos', value:'descripcion'},
      {text:'Codigo', value:'codigo'},
      {text:'Cantidad ', value:'cantidad'},
      {text:'IGV', value:'igv'},
      {text:'Unidad de medida', value:'nombre_unidad_de_medida'},
      {text:'Precio unitario', value:'precio_unitario'},
      {text:'Total', value:'total'}
    ],
  }),
  props:{
    llave : String,
    idCotizacion : String,
    dialog:Boolean,
  },
  methods:{
      cerrar(){
        this.$emit('dialog',false)
      },
    ...mapActions({
      get : 'Outputs/get',
    }),

  },
  computed: {
    ...mapState({
      Datos :state=> state.Outputs.data,
      Customers: state=>state.Customers.data,
    }),
    ...mapGetters({
      Propuestas: 'Outputs/registro',
      registro_de_credenciales: 'Credenciales/registro'

    })
  },
  components:{
    Boton_imprimir:()=>import ('@/components/boton_imprimir')
  },
}
</script>